import React from "react";
import RedirectTo from "components/RedirectTo/RedirectTo";
import type { RootState } from "app/store";
import { useSlc } from "app/store";
import { WrapperUserRating } from "app/wrappers";

export const Rating = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);
  if (isAuth) return <WrapperUserRating />;
  return <RedirectTo path="/sign-in" />;
};
